import { render, staticRenderFns } from "./topInfo.vue?vue&type=template&id=61a372e2&scoped=true&"
import script from "./topInfo.vue?vue&type=script&lang=js&"
export * from "./topInfo.vue?vue&type=script&lang=js&"
import style0 from "./topInfo.vue?vue&type=style&index=0&id=61a372e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a372e2",
  null
  
)

export default component.exports